import styled, { css } from 'styled-components'
import { TEXT } from '../../shared/styles/colors';

export const Question = styled.button`
  width: 100%;
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  background-color: white;
  padding: 12px 66px 12px 24px;
  box-sizing: border-box;
  height: 60px;

  text-align: left;
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${TEXT};
  text-overflow: ellipsis;
  overflow: hidden;
  
  &:after {
    content: '+';
    position: absolute;
    right: 22px;
    top: 22px;
    font-size: 15px;
    color: #646464;
  }

  @media (min-width: 600px) {
    padding-left: 36px;
    padding-right: 79px;
  }

  ${({withborder}) => withborder && css`
    border: 1px solid #DDE0E5;
    box-shadow: none;
  `}
`